import React, { useMemo } from 'react';
import {
  ComponentDescriptor,
  ComponentRenderer,
} from '../../../src/components/PageBuilder';

export type ComponentDescriptorOrArray =
  | ComponentDescriptor
  | ComponentDescriptor[];

export const getRendererFromDescriptor = (
  descriptor?: ComponentDescriptorOrArray
) => {
  if (!descriptor) return null;
  return Array.isArray(descriptor) ? (
    descriptor.map((d, i) => (
      <ComponentRenderer serializedComponent={d} key={d.type + '-' + i} />
    ))
  ) : (
    <ComponentRenderer serializedComponent={descriptor} key={descriptor.type} />
  );
};

export const useComponentDescriptor = (
  descriptor?: ComponentDescriptorOrArray
) => {
  return useMemo(() => getRendererFromDescriptor(descriptor), [descriptor]);
};
